module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-page"
  }, [_c('div', {
    staticClass: "phone-viewport"
  }, [_c('md-toolbar', [_c('md-button', {
    staticClass: "md-icon-button",
    nativeOn: {
      "click": function($event) {
        _vm.toggleLeftSidenav($event)
      }
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('span', {
    staticClass: "whata-logo whata-logo-small"
  }), _vm._v(" "), _c('h2', {
    staticClass: "md-title"
  }, [_vm._v("Whata "), _c('span', {
    staticClass: "md-subheading"
  }, [_vm._v("save the planet - classify water")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex": "1"
    }
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button"
  }, [_c('md-icon', [_vm._v("search")])], 1), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button"
  }, [_c('md-icon', [_vm._v("filter_list")])], 1)], 1), _vm._v(" "), _c('div', [_c('WaterMap')], 1), _vm._v(" "), _c('md-sidenav', {
    ref: "leftSidenav",
    staticClass: "md-left",
    on: {
      "open": function($event) {
        _vm.open('Left')
      },
      "close": function($event) {
        _vm.close('Left')
      }
    }
  }, [_c('md-toolbar', {
    staticClass: "md-large"
  }, [_c('div', {
    staticClass: "md-toolbar-container"
  }, [_c('h3', {
    staticClass: "md-title"
  }, [_vm._v("Sidenav content")])])]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nisi cupiditate esse necessitatibus beatae nobis, deserunt ut est fugit, tempora deleniti, eligendi commodi doloribus. Nemo, assumenda possimus, impedit inventore perferendis iusto!")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2be0d649"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainPage.vue
// module id = 38
// module chunks = 1